<style>
</style>
<template>
<v-container lighten-5>
    <v-row>
        <v-col cols="12" sm="12" md="12">
            <span class="mx-2 primary--text display-2 float-left">Usuarios</span>
        </v-col>
        <v-col cols="12" sm="12" md="12">
            <v-btn class="mx-2 float-right" fab small dark color="accent" @click="verFiltros=!verFiltros">
                <v-icon dark>filter_list</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12" sm="12" md="12">
            <v-card elevation="0" class="rounded-xl">
                <v-data-iterator :items="lista" :page.sync="page" :loading="loadingTable" :item-key="tabla.itemKey" :items-per-page="10" single-expand hide-default-footer :sort-by="tabla.orderBy">
                    <template v-slot:header>
                        <Dfiltros v-if="verFiltros" :onBuscar="search" v-bind:filtros="filtros" />
                        <v-toolbar dark  class="mb-1">
                            <v-btn class="mx-2 primary--text" tile color="white" @click.stop="dialog = true">
                                agregar
                            </v-btn>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <div class="flex-grow-1"></div>
                        </v-toolbar>
                    </template>
                    <template v-slot:default="{ items, isExpanded, expand }">
                        <v-container class="pt-0">
                            <v-row align="center" justify="center" :class="($vuetify.theme.dark)?'grey darken-4':'grey lighten-3'">
                                <v-col v-for="item in items" :key="item.id" cols="12" sm="10" md="10" lg="10">
                                    <v-card elevation="0" class="rounded-xl">
                                        <v-card-title :class="`${($vuetify.breakpoint.mdAndUp)?'subtitle-1':'subtitle-2'}  font-weight-bold`">
                                            <v-row no-gutters>
                                                <v-col cols="10" sm="10" md="10" lg="10">
                                                    <v-row no-gutters>
                                                        <v-col cols="12" sm="12" md="12" lg="12">
                                                            <v-row no-gutters>
                                                                <v-col cols="12" sm="12" md="3" lg="3">
                                                                    <v-icon :class="($vuetify.theme.dark)?'grey darken-4':'grey lighten-3'" color="primary" style="font-size:150px;">mdi-account</v-icon>
                                                                </v-col>
                                                                <v-col cols="12" sm="12" md="9" lg="9">
                                                                <template v-for="(p,i) in tabla.primarios">
                                                                    <v-col :cols="p.tamaño.cols" :sm="p.tamaño.sm" :md="p.tamaño.md" :lg="p.tamaño.lg" :key="i">
                                                                        {{p.titulo}} <span :class="p.class">
                                                                            {{ p.valor(item) }}
                                                                        </span>
                                                                    </v-col>
                                                                </template>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="2" sm="2" md="2" lg="2">
                                                    <v-menu bottom left>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon outlined v-bind="attrs" v-on="on">
                                                                <v-icon class="material-icons-two-tone">more_vert</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <v-list>
                                                            <template v-for="(m, i) in tabla.menu">
                                                                <template v-if="m.show(item)">
                                                                    <v-list-item v-if="m.tipeAction=='link'" :key="i" :to="m.action(item)">
                                                                        <v-list-item-icon>
                                                                            <v-icon :color="m.color">{{m.icon}}</v-icon>
                                                                        </v-list-item-icon>
                                                                        <v-list-item-title>{{ m.title }}</v-list-item-title>
                                                                    </v-list-item>
                                                                    <v-list-item v-else :key="i" @click="m.action(item)">
                                                                        <v-list-item-icon>
                                                                            <v-icon :color="m.color">{{m.icon}}</v-icon>
                                                                        </v-list-item-icon>
                                                                        <v-list-item-title>{{ m.title }}</v-list-item-title>
                                                                    </v-list-item>
                                                                </template>
                                                            </template>
                                                        </v-list>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                            <v-row no-gutters>
                                                <template v-for="(p,i) in tabla.segundarios">
                                                    <v-col :cols="p.tamaño.cols" :sm="p.tamaño.sm" :md="p.tamaño.md" :lg="p.tamaño.lg" :key="i">
                                                        {{p.titulo}} <span :class="p.class">
                                                            {{ p.valor(item) }}
                                                        </span>
                                                    </v-col>
                                                </template>
                                                <v-col cols="12" sm="12" md="12" lg="12" v-if="tabla.expandible">
                                                    <v-row>
                                                        <v-col cols="2" sm="2" md="1" lg="1">
                                                            <v-btn color="grey" icon outlined @click="() => expand(item, !isExpanded(item))">
                                                                <v-icon v-if="!isExpanded(item)">mdi-chevron-down</v-icon>
                                                                <v-icon v-else>mdi-chevron-up</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                        <v-col cols="10" sm="10" md="11" lg="11">
                                                            <span class="headline primary--text">{{tabla.expandibleTitle(item)}}</span>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                        <template v-if="tabla.expandible">
                                            <v-divider v-if="isExpanded(item)"></v-divider>
                                            <v-card-text v-if="isExpanded(item)">
                                                <v-container>
                                                    <template v-for="items in tabla.expandibleItems(item) ">
                                                        <v-sheet min-height="100%" width="100%" :key="items[tabla.expandibleKey]">
                                                            <v-row no-gutters :class="`${($vuetify.theme.dark)?'grey darken-4':'grey lighten-3'} mb-5 py-2 px-2`">
                                                                <template v-for="(p,i) in tabla.expanItem">
                                                                    <v-col :cols="p.tamaño.cols" :sm="p.tamaño.sm" :md="p.tamaño.md" :lg="p.tamaño.lg" :key="i">
                                                                        {{p.titulo}} <span :class="p.class">
                                                                            {{ p.valor(items) }}
                                                                        </span>
                                                                    </v-col>
                                                                </template>
                                                                <v-col cols="2" sm="2" md="2" lg="2" v-if="tabla.expanMenu.length > 0">
                                                                    <v-menu bottom left>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn icon outlined v-bind="attrs" v-on="on">
                                                                                <v-icon class="material-icons-two-tone">more_vert</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <v-list>
                                                                            <template v-for="(m, i) in tabla.expanMenu">
                                                                                <template v-if="m.show(items)">
                                                                                    <v-list-item v-if="m.tipeAction=='link'" :key="i" :to="m.action(items)">
                                                                                        <v-list-item-icon>
                                                                                            <v-icon :color="m.color">{{m.icon}}</v-icon>
                                                                                        </v-list-item-icon>
                                                                                        <v-list-item-title>{{ m.title }}</v-list-item-title>
                                                                                    </v-list-item>
                                                                                    <v-list-item v-else :key="i" @click="m.action(items)">
                                                                                        <v-list-item-icon>
                                                                                            <v-icon :color="m.color">{{m.icon}}</v-icon>
                                                                                        </v-list-item-icon>
                                                                                        <v-list-item-title>{{ m.title }}</v-list-item-title>
                                                                                    </v-list-item>
                                                                                </template>
                                                                            </template>
                                                                        </v-list>
                                                                    </v-menu>
                                                                </v-col>
                                                            </v-row>
                                                        </v-sheet>
                                                    </template>
                                                </v-container>
                                            </v-card-text>
                                        </template>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                    <template v-slot:no-data>
                        <v-row class="mt-2" align="center" justify="center">
                            <v-col cols="10" sm="10" md="10" lg="10">
                                <v-alert text dense color="primary" icon="mdi-database-search" border="left">
                                    No se encontro nada.
                                </v-alert>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:loading>
                        <v-row class="mt-2" no-gutters align="center" justify="center">
                            <v-col cols="12" sm="12" md="12" lg="12">
                                <Loader />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:footer>
                        <Paginacion v-on:cambiarPagina="page = $event" :onSearch="search" v-bind:propiedades="{filtros,page,pageCount,Count}" />
                    </template>
                </v-data-iterator>
            </v-card>
        </v-col>
    </v-row>

    <v-form @submit.prevent="agregar">
        <v-dialog v-model="dialog" persistent width="1400px" min-width="1400px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container>
                        <v-row v-if="loadingForm" align="center" justify="center">
                            <v-col cols="12" sm="12" md="12" lg="12">
                                <Loader />
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field label="username" dense outlined :error-messages="errores['username']" v-model="form.username" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field required label="email" dense outlined :error-messages="errores['email']" v-model="form.email"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-text-field type="password" dense v-model="form.password_hash" label="password" :error-messages="errores['password_hash']" outlined required />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field type="password" dense v-model="form.password_hash_confirmation" label="confirmar password" outlined required />
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-select v-model="form.roles" dense :items="perfiles" multiple chips small-chips item-text="description" :error-messages="errores['roles']" outlined item-value="name" label="perfil" clearable></v-select>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-select v-model="form.sucursalesFormat" dense :items="empresas" multiple chips small-chips item-text="tblConfPersonasempresas[0].coemNombre"  outlined item-value="tblConfPersonasempresas[0].coemId" label="sucursales" clearable></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="!isNew">
                                <v-switch v-model="form.status" label="Estado"></v-switch>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-for="(padre,i ) in padres" :key="i">
                                <label class="primary--text">{{padre.padre}}</label>
                                <v-row class="grey lighten-3">
                                    <v-col cols="4" sm="4" md="4" v-for="permiso in padre.permisos" :key="permiso.name">
                                        <v-checkbox v-model="permisos2" :label="permiso.description" :value="permiso.name"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="primary" text @click="close">Cancelar</v-btn>
                    <v-btn color="primary" :loading="loadingGuardar" dark @click="agregar">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</v-container>
</template>
<script>
import generales from '../../../mixins/generales.js';

export default {
    mixins: [generales],
    data() {
        return {
            url: "sistema/user/",
            perfiles: [],
            form: {
                username: "",
                email: "",
                roles: [],
                status: 1,
                password_hash: "",
                repassword: "",
                permisos: [],
                sucursales:"[]",
                sucursalesFormat:[]
            },
            permisos2: [],
            tabla: {
                itemKey: 'id',
                orderBy: 'id',
                expandible: false,
                expandibleKey: 'id',
                expandibleTitle: () => { return `` },
                expandibleItems: (item) => { return item },
                primarios: [{
                        titulo: 'USERNAME',
                        tamaño: {
                            cols: '9',
                            sm: '9',
                            md: '9',
                            lg: '9'
                        },
                        class: 'primary--text',
                        valor: (item) => { return item.username },
                        show: (item) => { return item ? true : false }
                    }, {
                        titulo: 'PERFIL',
                        tamaño: {
                            cols: '9',
                            sm: '9',
                            md: '9',
                            lg: '9'
                        },
                        class: 'primary--text',
                        valor: (item) => { return item.roles.map((rol) =>{ return rol.role;}).join() },
                        show: (item) => { return item ? true : false }
                    },
                    {
                        titulo: 'ESTADO',
                        tamaño: {
                            cols: '9',
                            sm: '9',
                            md: '9',
                            lg: '9'
                        },
                        class: 'primary--text',
                        valor: (item) => { return (item.status) ? 'ACTIVO' : 'INACTIVO' },
                        show: (item) => { return item ? true : false }
                    },

                ],
                segundarios: [{
                    titulo: 'EMAIL',
                    tamaño: {
                        cols: '12',
                        sm: '12',
                        md: '12',
                        lg: '12'
                    },
                    class: 'primary--text',
                    valor: (item) => { return item.email },
                    show: (item) => { return item ? true : false }
                } ],
                expanItem: [ ],
                expanMenu: [],
                menu: [{
                        title: 'Editar',
                        icon: 'create',
                        color: 'info',
                        tipeAction: 'funcion',
                        action: (item) => { this.dialog = true; return this.editar(item.id) },
                        show: (item) => { return item ? this.getPermiso('editarUser') : false }

                    },
                    {
                        title: 'Eliminar',
                        icon: 'delete',
                        color: 'error',
                        tipeAction: 'funcion',
                        action: (item) => { this.eliminar(item.id) },
                        show: (item) => { return item ? this.getPermiso('eliminarUser') : false }

                    },
                ]
            },
            filtros: [{
                campo: "username",
                text: "username",
                value: null,
                tipo: "text",
                search: true,
                isLoading: false,
            }, {
                campo: "email",
                text: "email",
                value: null,
                tipo: "text",
                search: true,
                isLoading: false,
            }, {
                
                campo: "role",
                text: "role",
                value: null,
                tipo: "lista",
                lista: [],
                listatext: "description",
                listavalue: "name"
            }, {
                campo: "status",
                text: "status",
                value: null,
                tipo: "text"
            }],
            listPermisos: [],
            padres: [],
            empresas:[]
        };
    },
    created: async function () {
        await this.search(this.filtros);
        this.filtros[2].lista = this.perfiles = await this.$apiService.index("sistema/perfiles/index/1").then(data => data);
        this.empresas = await this.$apiService.index("sistema/personas/index/empresas").then(data => data);
        let tipoempresa = await this.$apiService.index("sistema/maestra/index/TBL_TIPOEMPRESA").then(data => data);
        this.empresas = this.empresas.filter( e => e.tblConfPersonasempresas[0].coemTipoTipoempresa == (tipoempresa.find(a => a.comaNombrecorto == 'EMP_SUCURSAL').comaId))
        this.listPermisos = await this.$apiService.index("sistema/perfiles/index/2").then(data => data);
        this.listPermisos.sort((a, b) => (a.padre < b.padre) ? -1 : 1);
        this.listPermisos.forEach(element => {
            if (this.padres.find(e => e.padre == element.padre) == undefined) {
                this.padres.push({ padre: element.padre, permisos: this.listPermisos.filter(e => e.padre == element.padre) });
            }
        });
    },

    methods: {
        async search(filtros) {
            this.lista = this.listaCopia = [];
            this.loadingTable = true;
            const data = await this.$apiService.index(`${this.url}buscar?${this.filtrar(filtros,this.page)}`).then(data => data);
            if (data) {
                this.lista = this.listaCopia = data.rows;
                this.Count = data.count;
                this.pageCount = Math.ceil((data.count) / 10);
            }
            this.loadingTable = false;
        },

        async agregar() {
            try {
                this.errores = [];
                this.loadingGuardar = true;
                if (this.permisos2.length > 0) {
                    this.permisos2.forEach((permiso) => {
                        this.form.permisos.push((!this.isNew) ? { userId: this.form.id , itemName: permiso } : { itemName: permiso });
                    });
                }
                this.form.sucursales = JSON.stringify(this.form.sucursalesFormat);
                let data = (this.isNew) ? await this.$apiService.create(`${this.url}create/`, this.form).then((data) => data) :
                    await this.$apiService.update(`${this.url}update/${this.form.id}`, this.form).then((data) => data);
                if (data) {
                    this.close();
                    this.$swal.fire({
                        title: "Completado!",
                        text: "Registro exitoso",
                        icon: "success",
                        confirmButtonText: "Ok"
                    });
                    await this.search(this.filtros);
                }

            } catch (error) {
                this.getErrores(error);
            }
            this.loadingGuardar = false;

        },
        async eliminar(id) {
            try {
                let result = await this.$swal.fire({
                    title: "Estas seguro?",
                    text: "No podras revertir esto!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Si, eliminar!"
                }).then(result => result.value);
                if (result) {
                    var data = await this.$apiService.delete(`${this.url}delete/${id}`).then(data => data);
                    if (data) {
                        await this.search(this.filtros);
                        this.$swal.fire(
                            "Eliminado!",
                            "ha sido eliminado con exito.",
                            "success"
                        );
                    }
                }
            } catch (error) {
                this.$swal.fire({
                    title: "Algo sucedio!",
                    text: "contacta con el administrador",
                    icon: "error"
                });
            }

        },
        async editar(id) {

            try {
                this.loadingForm = true;
                this.form = await this.$apiService.index(`${this.url}view/${id}`).then(data => data);
                this.permisos2 = [];
                this.form.permisos.forEach((permiso) => {
                    this.permisos2.push(permiso.itemName);
                });
                this.form.permisos = [];
                this.form.roles = this.form.roles.map((rol) =>{
                     return rol.role;
                });
                this.form.sucursalesFormat = JSON.parse(this.form.sucursales);
                this.isNew = false;
                this.loadingForm = false;
            } catch (error) {
                this.$swal.fire({
                    title: "Algo sucedio!",
                    text: "contacta con el administrador",
                    icon: "error"
                });
            }

        },
        limpiar() {
            this.form = {
                username: "",
                email: "",
                roles: [],
                status: 1,
                password_hash: "",
                repassword: "",
                permisos: []
            };
        },
        close() {
            this.errores = [];
            this.isNew = true;
            this.dialog = false;
            this.limpiar();
        }
    }
};
</script>